import { render } from "./LeadgenFormsView.vue?vue&type=template&id=04661753"
import script from "./LeadgenFormsView.vue?vue&type=script&lang=js"
export * from "./LeadgenFormsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/LeadgenFormsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04661753"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04661753', __exports__)) {
    api.reload('04661753', __exports__)
  }
  
  module.hot.accept("./LeadgenFormsView.vue?vue&type=template&id=04661753", () => {
    api.rerender('04661753', render)
  })

}


export default __exports__